export enum EN_UI_PLUGIN_SYMBOL {}

export interface IUIPluginManager {
  register(symbol: EN_UI_PLUGIN_SYMBOL, service: any, description?: string): void;
  getPlugins(symbol: EN_UI_PLUGIN_SYMBOL): JSX.Element[];
}
